<template>
    <div>

        <b-alert v-if="error" show variant="danger" class="mt-2">
           {{errorMsg}}
        </b-alert>

        <b-overlay :show="busy">

                <div>
                    <span class="font-weight-bold">Your Account</span>
                </div>

                <b-row>
                    <b-col cols="6" md="3">
                        Username
                    </b-col>
                    <b-col cols="6" md="9">
                        <b>{{form.username}}</b>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6" md="3">
                        Name
                    </b-col>
                    <b-col cols="6" md="9">
                        <b>{{form.firstname+' '+form.lastname}}</b>
                    </b-col>
                </b-row>

                <div class="mt-2">
                    <span class="font-weight-bold">CE Quick Glance</span>
                </div>
                <b-row>
                    <b-col cols="6" md="3">
                        Self-Study
                    </b-col>
                    <b-col cols="6" md="9">
                        <b>{{summary.ceHome}} credits</b>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6" md="3">
                        Live interactive
                    </b-col>
                    <b-col cols="6" md="9">
                        <b>{{summary.ceLive}} credits</b>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6" md="3">
                        Total
                    </b-col>
                    <b-col cols="6" md="9">
                        <b>{{summary.ceTotal}} credits</b>
                    </b-col>
                </b-row>

                <transition name="fade" mode="out-in">
                  <b-alert v-if="error" key="error-box" show variant="danger" dismissible class="mt-2">
                    {{errorMsg}}
                  </b-alert>
                  <b-alert v-if="success" key="success-box" show variant="success" dismissible class="mt-2">
                    Check email inbox for CE report.
                  </b-alert>
                </transition>

                <b-form @submit.stop.prevent="submit" class="mt-2">
                    <div class="text-center mb-2">
                        <b-button type="submit" variant="info">Send CE Report</b-button>
                    </div>
                </b-form>

        </b-overlay>
    </div>
</template>

<script>
/* eslint-disable */

import service from "@/service/service"
import utils from "@/utils/utils"

export default {
    name: "AccountHome",
    data() {
        return {
            debug: false,
            error: false,
            errorMsg: 'System error - contact tech support.',
            loading: false,
            busy: false,
            success: false,
            msg: '',
            checkbox: null,
            form: this.value,
            summary: { ceHome: 0.0, ceLive: 0.0, ceTotal: 0.0}
        }
    },
    props: {
        // student object. the v-model for the component
        value: {
            type: Object,
            default: {}
        }
    },
    watch: {
        form: {
            deep: true,
            handler(vmodel) {  // receives updated this.form
            // console.log('watcher')
            // console.log(vmodel)
            // Send updated model to parent.
            this.$emit('input', vmodel)  // send to listeners as input event
            }
        }
    },
    computed: {},
    methods: {
        submit(e) {

            this.error = false
            this.success = false
            this.busy = true;

            service
                .sendReport(this.form.hash)
                    .then( res => {
                    if (this.debug) console.log(res.data);
                    if (res.status) {
                        this.success = true
                    }
                    else {
                        this.success = false
                        this.errorMsg = data.msg || 'Service error.'
                        this.error = true
                    }
                    })
                    .finally( () => {
                        this.busy = false
                    })
                    .catch(e => {
                        console.log(e)
                        this.error = true
                    })
        }
    },
    created() {

        if (this.form.hash.length !== 0) {
            this.busy = true
            service
            .getAccountHome(this.form.hash)
            .then(
                (res => {
                // console.log(`back from getAccountHome!`)
                if (this.debug) console.log(res)
                if (res.status) {
                    // TBD populate stuff
                    this.summary = res.summary
                }
                else {
                    this.error = true
                }
                }).bind(this)
            )
            .finally(e => {
                this.busy = false;
                // console.log(`finally...`);
            })
            .catch(e => {
                this.error = true
                console.log(e);
            });
        }
        else {
            // flag error!
        }
    },
    mounted() {
        console.log(`AccountHome mounted`)
    },
    beforeDestroy() {
        console.log(`AccountHome beforeDestroy`)
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AccountHome.vue